import { useEffect, useState, type FormEvent } from 'react'
import { motion } from 'framer-motion'
import { Eye, EyeOff, KeyRound, ShieldCheck } from 'lucide-react'
import { api } from '../api'
import { BrandLockup } from '../components/Brand'

// Mesma composição da tela de login do aplicativo (AuthScreen): cabeçalho com a
// marca ao centro, cartão estreito com título centralizado e botão de largura total.
export function LoginPage({ onSuccess }: { onSuccess: () => void }) {
  const [code, setCode] = useState('')
  const [visible, setVisible] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // As telas públicas do app são sempre escuras, mesmo com o tema claro salvo.
  useEffect(() => {
    const root = document.documentElement
    const previous = root.dataset.theme
    delete root.dataset.theme
    root.style.colorScheme = 'dark'
    return () => { if (previous) root.dataset.theme = previous }
  }, [])

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await api('/auth/login', { method: 'POST', body: { code } })
      onSuccess()
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Código inválido.')
    } finally {
      setLoading(false)
    }
  }

  return <main className="auth-page auth-mode-login">
    <header className="auth-header">
      <span/>
      <div className="auth-header-brand"><BrandLockup/></div>
      <span className="auth-security"><ShieldCheck aria-hidden="true"/> Ambiente protegido</span>
    </header>
    <motion.section className="auth-card auth-login-card" aria-labelledby="login-title" initial={{ opacity: 0, y: 18, scale: .985 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ type: 'spring', stiffness: 260, damping: 28 }}>
      <div>
        <h2 id="login-title">Bem-vindo ao Admin</h2>
        <p>Informe seu código de acesso para continuar.</p>
      </div>
      <form onSubmit={submit}>
        <label htmlFor="access-code">Código de acesso
          <div className="input-icon">
            <KeyRound aria-hidden="true"/>
            <div className="password-field">
              <input id="access-code" value={code} onChange={event => setCode(event.target.value)} type={visible ? 'text' : 'password'} autoComplete="current-password" autoFocus required aria-invalid={Boolean(error)} placeholder="Digite o código" aria-describedby={error ? 'login-error' : undefined}/>
              <button type="button" className="password-toggle" onClick={() => setVisible(value => !value)} aria-pressed={visible} aria-label={visible ? 'Ocultar código' : 'Exibir código'} title={visible ? 'Ocultar código' : 'Exibir código'}>{visible ? <EyeOff/> : <Eye/>}</button>
            </div>
          </div>
        </label>
        <button type="submit" className="primary" disabled={loading}>{loading ? <><span className="spinner small" aria-hidden="true"/>Validando…</> : 'Entrar'}</button>
      </form>
      {error && <p id="login-error" className="form-message" role="alert">{error}</p>}
    </motion.section>
  </main>
}
